import { IDatiqGeoSuggestion } from '@dat/iq-proxy';
import { z } from 'zod';

export interface IIqRateLaneUtilsStateService {
    getGeo(location: string): Promise<IDatiqGeoSuggestion>;
    getMileage(origin: string, destination: string): Promise<number>;
}

export const GraphQlHistoricalSchema = z.object({
    rate: z.object({
        average: z.object({
            perTrip: z.object({
                value: z.number()
            }),
            perMile: z.object({
                value: z.number().nullable()
            })
        }),
        high: z.object({
            perTrip: z.object({
                value: z.number()
            }),
            perMile: z.object({
                value: z.number().nullable()
            })
        }),
        low: z.object({
            perTrip: z.object({
                value: z.number()
            }),
            perMile: z.object({
                value: z.number().nullable()
            })
        }),
        mileage: z.number().nullable(),
        reports: z.number(),
        companies: z.number(),
        timeEscalation: z.string(),
        area: z.string(),
        areaDestination: z.string(),
    })
});

export type GraphQlHistorical = z.infer<typeof GraphQlHistoricalSchema>;


export enum IqErrorStateProv {
    AK = 'AK', // Alaska
    HI ='HI', // Hawaii
    PR = 'PR', // Puerto Rico
    GU = 'GU', // Guam
    AG = 'AG', // Mexico
    BJ = 'BJ', // Mexico
    EM = 'EM', // Mexico
    CH = 'CH', // Mexico
    CI = 'CI', // Mexico
    CP = 'CP', // Mexico
    CU = 'CU', // Mexico
    CL = 'CL', // Mexico
    DG = 'DG', // Mexico
    GJ = 'GJ', // Mexico
    GR = 'GR', // Mexico
    HG = 'HG', // Mexico
    JA = 'JA', // Mexico
    DF = 'DF', // Mexico
    MH = 'MH', // Mexico
    MR = 'MR', // Mexico
    NA = 'NA', // Mexico
    NL = 'NL', // Mexico
    OA = 'OA', // Mexico
    PU = 'PU', // Mexico
    QA = 'QA', // Mexico
    QR = 'QR', // Mexico
    SL = 'SL', // Mexico
    SI = 'SI', // Mexico
    SO = 'SO', // Mexico
    TA = 'TA', // Mexico
    TM = 'TM', // Mexico
    TL = 'TL', // Mexico
    VL = 'VL', // Mexico
    YC = 'YC', // Mexico
    ZT = 'ZT', // Mexico
}
